import React from 'react'
import PoleNameView from './PoleNameView/PoleNameView'
import { useSingleStreetLight } from '../../../../hooks'

export default function PoleNamePresenter() {

    const {    singlePoleQuery:{data, isLoading}}= useSingleStreetLight()
    if(isLoading) return <div>Loading...</div>
  return (
    <PoleNameView name={data?.pole_name}/>
  )
}
